import React from 'react';
import CompaniesContainer from './CompaniesContainer';

const Companies = () => <CompaniesContainer />;

export default Companies;
